import ReactApexChart from 'react-apexcharts';
import { Calendar } from 'lucide-react';
import { useEffect, useState } from 'react';
import DataNotFound from '../ui/loader/data-not-found';
import InnerLoader from '../ui/loader/inner-loader';
import { ChartMainCard } from './ChartsHeader';
import { TeamAvailability } from './StatCardIcons';


export function LeadsBySource({ sourceData = [], sourceDataTotal, sourceLoading }) {

  // const colors = [
  //   '#f26522', // orange
  //   '#1b84ff', // blue
  //   '#ffc107', // yellow
  //   '#ab47bc', // purple

  //   '#10b981', // emerald green
  //   '#ef4444', // red
  //   '#0f766e', // teal
  //   '#f43f5e', // rose
  //   '#22c55e', // green
  //   '#6366f1', // indigo
  // ];

const colors = [
  "#1E3A8A", // deep blue
  "#60A5FA", // light sky blue

  "#9D174D", // deep rose
  "#FB7185", // soft pink

  "#065F46", // deep emerald
  "#34D399", // mint green

  "#7C2D12", // burnt brown
  "#FDBA74", // soft orange

  "#4C1D95", // dark violet
  "#A78BFA", // lavender
];

  const [chartOptions] = useState({
    chart: {
      type: 'radialBar',
      height: 320,
    },
    plotOptions: {
      radialBar: {
        offsetY: -10,
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 5,
          size: '45%',
          background: 'transparent',
        },
        dataLabels: {
          show: false,
        },
        track: {
          background: '#f2f2f2',
          strokeWidth: '100%',
        },
      },
    },
    colors: colors,
    labels: sourceData?.map(eachStatus => eachStatus?.label) || [],
    legend: {
      show: false,
    },
    stroke: {
      lineCap: 'round',
    },
  });

  const series = sourceData?.map(eachStatus => eachStatus?.count) || [];

  // const statusData = [
  //   { label: 'Open', value: 653, color: 'bg-[#f26522]' },
  //   { label: 'In Progress', value: 342, color: 'bg-[#1b84ff]' },
  //   { label: 'On Hold', value: 185, color: 'bg-[#ffc107]' },
  //   { label: 'Closed', value: 67, color: 'bg-[#ab47bc]' },
  // ];

  const statusData = sourceData?.map((eachStatus, i) => ({ label: eachStatus?.label, value: eachStatus?.count, color: colors[i] })) || []

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-blue-light text-theme-blue'}
      heading="Marketing Channel Performance"
      subHeading={"Lead generation comparison across Website and Direct sources"}
      // , Ads, Referral,
    >
      <div className="p-6 flex-1">
        {!sourceLoading ?
          <div className="h-[320px]">
            <InnerLoader />
          </div>
          :
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
            <div className="flex items-center justify-center">
              <ReactApexChart
                options={chartOptions}
                series={series}
                type="radialBar"
                height={320}
              />
            </div>
            <div>
              <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-200">
                <p className="text-sm text-gray-600 mb-0">Total Leads</p>
                <h2 className="text-3xl font-bold">{sourceDataTotal ?? 0}</h2>
              </div>
              <div className="space-y-3">
                {statusData?.map((status, idx) => (
                  <div key={idx} className="flex items-center justify-between py-2">
                    <div className="flex items-center gap-2">
                      <span
                        className={`w-3 h-3 rounded-full `}  //bg-[${status.color}]
                        style={{ backgroundColor: status.color }}
                      />
                      <span className="text-sm text-gray-700">{status.label}</span>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">{status.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        }
      </div>
    </ChartMainCard>



  );
}